import { addDays, isBefore } from 'date-fns';

import { GameProvider } from '@/globalTypes';

export const CLONE_NAME_SUFFIX = ' (copy)';

export const getCloneName = (name: string) => `${name}${CLONE_NAME_SUFFIX}`;

/**
 * A clone can't start in the past, so past dates are moved to now.
 * An end date that already passed is replaced by the create form default.
 */
export const getCloneDates = (
  startsAt: string | Date,
  endsAt?: string | Date | null,
  now = new Date(),
) => {
  const start = new Date(startsAt);
  const end = endsAt ? new Date(endsAt) : null;

  const clonedStart = isBefore(start, now) ? now : start;
  const clonedEnd =
    end && isBefore(clonedStart, end) ? end : addDays(clonedStart, 14);

  return { startsAt: clonedStart, endsAt: clonedEnd };
};

/** Finds the `GameProvider` matching a provider name, ignoring case */
export const toGameProvider = (
  ...providerNames: (string | null | undefined)[]
): GameProvider | undefined => {
  const providers = Object.values(GameProvider);

  for (const providerName of providerNames) {
    const match = providers.find(
      (provider) => provider.toLowerCase() === providerName?.toLowerCase(),
    );
    if (match) {
      return match;
    }
  }

  return undefined;
};

type GameDescriptorOrError =
  | { __typename: 'GameDescriptorV2'; json: any }
  | { __typename: string }
  | null
  | undefined;

export const getGameDescriptorJson = (
  gameDescriptor: GameDescriptorOrError,
): Record<string, any> | undefined =>
  gameDescriptor && 'json' in gameDescriptor ? gameDescriptor.json : undefined;

export const getGameDescriptorProviderName = (
  json?: Record<string, any>,
): string | undefined => json?.gameProvider?.name ?? json?.provider;
